const Details = [
  {
    id: 1,
    hobby: "Discover Amazing Books",
    icon: "📚",
    description:"Explore a curated collection of books tailored to your interests."
  },
  {
    id: 2,
    hobby: "Effortless Borrowing",
    icon: "🚀",
    description:"Experience a seamless borrowing process with just a few clicks."
  },
  {
    id: 3,
    hobby: "Smart Management",
    icon: "📊",
    description:"Effortlessly manage your book loans and returns with our intuitive system."
  },
];

export default Details;

export const dashboardItems = [
  {
    title: "Total Books",
    value: 1200,
    icon: "📚",
    color: "text-blue-600"
  },
  {
    title: "Books Available",
    value: 350,
    icon: "📖",
    color: "text-green-600"
  },
  {
    title: "Active Borrowers",
    value: 45,
    icon: "👥",
    color: "text-purple-600"
  },
  {
    title: "Total Borrowers",
    value: 100,
    icon: "📋",
    color: "text-purple-600"
  }
];